<script>
import Vue from 'vue'
import NavBar from '@components/nav-bar.vue'
import Breadcrumb from '@components/breadcrumb.vue'
import Error from '@components/error.vue'
import Footer from '@components/footer.vue'
import Modal from '@components/shared/modal.vue'
import FormGenerator from '@components/forms/FormGenerator.vue'

// import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

import { formattedMoment } from '@utils/helpers.js'

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    NavBar,
    Breadcrumb,
    Error,
    Footer,
    Modal,
    'form-generator': FormGenerator,
    DateRangePicker,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    breadcrumb: {
      type: Array,
      default() {
        return []
      },
    },
    lastUpdated: {
      type: Array,
      default() {
        return []
      },
    },
    error: {
      type: String,
      default() {
        return ''
      },
    },
    paramsSchema: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    selectedDateRange: {
      get() {
        return this.$store.getters['flights/getSelectedFlightDate']
      },
      set(payload) {
        this.$store.dispatch('flights/SET_SELECTED_FLIGHT_DATE', payload)
      },
    },
    modalId() {
      return `flightsModal${this.id}`
    },
  },
  methods: {
    formattedMoment: formattedMoment,
    openParams() {
      this.$bvModal.show(`flightsModal${this.id}`)
    },
    clearParams() {
      Vue.set(this, 'params', {})
    },
    dateFormat(classes, date) {},
    updateValues(e) {},
    checkOpen(e) {},
  },
}
</script>

<template>
  <div class="layout layout-nav-side">
    <NavBar />

    <div class="main-container">
      <Breadcrumb>
        <template v-slot:slot3>
          <DateRangePicker
            v-if="params.rollFlights === false"
            ref="picker"
            v-model="selectedDateRange"
            class="ml-2 date-range"
            :linked-calendars="true"
            opens="left"
            :locale-data="{firstDay: 1, format: 'DDMMMYYYY'}"
            :single-date-picker="true"
            :time-picker="false"
            :time-picker24-hour="true"
            :show-week-numbers="true"
            :show-dropdowns="true"
            :ranges="false"
            :auto-apply="true"
            @update="updateValues"
            @toggle="checkOpen"
          >
            <template v-slot:input="picker" style="min-width: 350px;">
              {{
              formattedMoment(picker.startDate, 'ddd DDMMMYY')
              }}
            </template>
          </DateRangePicker>
          <button
            v-if="$resize && $mq.above(992)"
            class="btn btn-sm ml-1"
            :class="Object.keys(params).length > 0 ? 'btn-light' : 'btn-light'"
            @click="openParams"
          >
            <b-icon icon="gear-fill"></b-icon>
          </button>
        </template>
      </Breadcrumb>

      <slot v-if="!error" />

      <Error v-if="error" :error="error.data" />

      <Footer :last-updated="lastUpdated" />
    </div>

    <Modal :id="modalId" title="Flights View Parameters" @clear="clearParams">
      <form-generator v-model="params" :schema="paramsSchema"></form-generator>
      <!-- <code>{{params}}</code>
      <template slot="default">This is where the parameters will go!</template>-->
    </Modal>
  </div>
</template>

<style>
.form-control.reportrange-text {
  border: 0;
  padding: unset;
  height: 23px;
  padding: 0 15px;
  background: #efefef;
  font-weight: 600;
  color: inherit;
  border-radius: 4px;
}
.daterangepicker.opensleft {
  top: 32px !important;
  right: 0 !important;
  left: auto;
}
.daterangepicker td.in-range {
  background-color: #00878f2e;
}
.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #00878f;
}
</style>
